import React, { Component } from 'react'
import { range, timer, easeCubic } from 'd3'

// get DPI
let dpi = window.devicePixelRatio

const data = {
  einkommensklasse: [50, 40, 9, 0.99, 0.01],
  steuerbeteiligung: [10.79, 35.61142703, 29.68911209, 19.46085515, 4.45175237],
  anzahl: [2533932, 1266966, 760179, 253393, 202715, 25339, 20271, 4561, 507],
  bezeichnungen: ['Ärmste 50%', '', '', '', 'Reichste 0.01%'],
  color: [
    '#E23C4E',
    '#1D5F82',
    '#F8813D',
    '#54AF71',
    '#456558',
    '#FFCA18',
    '#525394',
    '#AD427F',
    '#5A686D'
  ]
}

const height = 480 // window.innerHeight * 0.75;
const width = 400 // window.innerWidth * 0.7;
const numPoints = 600
const pointWidth = 3
const pointMargin = 3
const barMargin = 25
const graphBorder = 35
const font = ' TamediaChart,Helvetica,Arial,sans-serif'

// animation settings
const duration = 1000
const ease = easeCubic

// generate the array of points with a unique ID and color
let points = []
let pointsRight = []

data['steuerbeteiligung'].forEach((klasse, i) => {
  let subpoints = range(numPoints).map(index => ({
    id: index,
    class: i,
    color: data['color'][i]
  }))

  pointsRight.push.apply(pointsRight, subpoints)
})

data['einkommensklasse'].forEach((klasse, i) => {
  // let subpoints = range((numPoints / 100) * klasse).map(index => ({
  //   id: index,
  //   class: i,
  //   color: data['color'][i]
  // }))
  // points.push.apply(points, subpoints)
})

function gridLayout(points, pointWidth, side) {
  const pointHeight = pointWidth
  const pointsPerBar = Math.floor(
    (height -
      2 * graphBorder -
      (data['einkommensklasse'].length - 1) * barMargin) /
      data['einkommensklasse'].length /
      6
  )
  let group = 1
  let reset = 0
  let pct = 0
  points.forEach(point => {
    if (group !== point.class) {
      reset = 0
      pct = 0
      group = point.class
    }
    if (side === 'left') {
      point.x =
        width / 2 -
        pointHeight -
        pointWidth * Math.floor(reset / pointsPerBar) -
        30
      point.y =
        height -
        pointWidth * (reset % pointsPerBar) -
        point.class * (pointWidth * pointsPerBar + barMargin) -
        30
      if (group === 0) {
      }
    } else if (side === 'right') {
      if (data['steuerbeteiligung'][group] > pct) {
        point.x =
          width / 2 +
          pointHeight +
          pointWidth * Math.floor(reset / pointsPerBar) +
          30 -
          70
        point.y =
          height -
          pointWidth * (reset % pointsPerBar) -
          point.class * (pointWidth * pointsPerBar + barMargin) -
          30
        if (group === 0) {
        }
      } else {
        point.x = width + 20
        point.y = height * Math.random()
      }
      pct += 100 / numPoints
    }
    reset += 1
  })
  return points
}

const toGrid = points => gridLayout(points, pointWidth + pointMargin, 'right')

class GraphFull extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: width,
      height: height,
      layout: 'toGrid'
    }
  }

  animate(ctx) {
    pointsRight.forEach(point => {
      point.sx = point.x
      point.sy = point.y
    })

    data['steuerbeteiligung'] = this.props.pct

    let layout = toGrid
    pointsRight = layout(pointsRight)

    pointsRight.forEach(point => {
      point.tx = point.x
      point.ty = point.y
    })
    // get destination x and y position on each point

    let time = timer(elapsed => {
      // compute how far through the animation we are (0 to 1)
      const t = Math.min(1, ease(elapsed / duration))

      // update point positions (interpolate between source and target)
      pointsRight.forEach(point => {
        point.x = point.sx * (1 - t) + point.tx * t
        point.y = point.sy * (1 - t) + point.ty * t
      })

      // update what is drawn on screen
      this.draw(ctx, points, pointsRight)

      if (t >= 1) {
        time.stop()
      }
    })
  }

  fixDpi(canvas, ctx) {
    // get CSS height
    // the + prefix casts it to an integer
    // the slice method gets rid of "px"
    // Give the canvas pixel dimensions of their CSS
    // size * the device pixel ratio.
    canvas.width = width * dpi
    canvas.height = height * dpi

    ctx.scale(dpi, dpi)
    return ctx
  }

  draw(ctx, points, pointsRight) {
    ctx.save()
    ctx.clearRect(0, 0, width, height)
    ctx.lineWidth = 0.4
    ctx.strokeStyle = 'black'
    ctx.beginPath()
    ctx.moveTo(this.state.width / 2 - 40, 0)
    ctx.lineTo(this.state.width / 2 - 40, this.state.height)
    ctx.stroke()
    ctx.font = '18px' + font
    ctx.fillStyle = 'rgba(0, 0, 0)'
    ctx.fillText('Anteil Steuereinnahmen', this.state.width / 2 - 35, 20)

    data['steuerbeteiligung'].forEach((klasse, i) => {
      ctx.strokeStyle = data['color'][i]
      ctx.beginPath()
      ctx.moveTo(this.state.width / 2 - 35, 460 - 85 * i)
      ctx.lineTo(this.state.width - 40, 460 - 85 * i)
      ctx.stroke()
      ctx.beginPath()
      ctx.moveTo(40 - 5, 460 - 85 * i)
      ctx.lineTo(this.state.width / 2 - 45, 460 - 85 * i)
      ctx.stroke()
      ctx.font = '15px' + font
      ctx.fillStyle = 'rgba(0, 0, 0, 0.7)'
      ctx.fillText(
        data['steuerbeteiligung'][i].toFixed(2).replace('.', ',') + '%',
        this.state.width / 2 - 35,
        475 - 85 * i
      )
      ctx.fillText(
        // data['einkommensklasse'][i].toFixed(2).replace('.', ',') + '%',
        // this.state.width / 2 - 175,
        // 475- 85 * i
        data['bezeichnungen'][i],
        this.state.width / 2 - 175,
        475 - 85 * i
      )
    })

    for (let i = 0; i < points.length; ++i) {
      const point = points[i]
      ctx.fillStyle = point.color
      if (point.class === 4) {
        ctx.fillRect(point.x, point.y, 1, 1)
      } else {
        ctx.fillRect(point.x, point.y, pointWidth, pointWidth)
      }
    }
    for (let i = 0; i < pointsRight.length; ++i) {
      const point = pointsRight[i]
      ctx.fillStyle = point.color
      ctx.fillRect(point.x, point.y, pointWidth, pointWidth)
    }
    ctx.restore()
  }

  componentDidMount() {
    const canvas = this.refs.canvas
    let ctx = canvas.getContext('2d')
    ctx = this.fixDpi(canvas, ctx)
    // gridLayout(points, pointWidth + pointMargin, width)
    points = gridLayout(points, pointWidth + pointMargin, 'left')
    pointsRight = gridLayout(pointsRight, pointWidth + pointMargin, 'right')

    this.draw(ctx, points, pointsRight)
  }

  componentDidUpdate() {
    const canvas = this.refs.canvas
    const ctx = canvas.getContext('2d')
    this.animate(ctx)
  }

  render() {
    return <canvas className='fullCanvas' ref='canvas' />
  }
}

export default GraphFull
